export default __webpack_public_path__ + "static/media/gn.fcc7731e.svg";